<template>
  <div class="items has-text-centered">
    <div class="notice">
      <p>{{ notice }}</p>
    </div>

    <div
      class="item-level"
      v-for="(leveledItems, i) in levels(items)"
      :key="'items-level-' + i"
    >
      <div
        class="item"
        :class="{ selected: isSelectedItem(item) }"
        @click="toggleSelect(item)"
        v-for="item in leveledItems"
        :key="item.name"
      >
        <img :src="itemUrl(item)">
      </div>
    </div>

    <div class="notice">
      <p :style="{ color: '#3FB7A2' }">You can only have one element in use at a time</p>
    </div>

    <div
      class="item-level"
      v-for="(leveledElements, i) in levels(elements)"
      :key="'elements-level-' + i"
    >
      <div
        class="item"
        :class="{ selected: isSelectedElement(element) }"
        @click="selectElement(element)"
        v-for="element in leveledElements"
        :key="element.name"
      >
        <img :src="elementUrl(element)">
      </div>
    </div>
  </div>
</template>

<script>
  import CircleSelect from "@/components/CircleSelect";
  import { mapState, mapActions } from "vuex";

  const lockedBoxUrl = require("@/assets/icons/loot-box-gold.svg");

  export default {
    name: "LootSelect",
    components: {
      CircleSelect
    },
    data() {
      return {
        // TODO based upon number of items unlocked
        notice: "Bond with your pathfinder to earn more items"
      };
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        items: state => state.items.items,
        elements: state => state.elements.elements
      })
    },
    methods: {
      ...mapActions(["toggleItem", "toggleElement"]),
      levels(items) {
        let finalArray = [],
          // TODO change for different screen widths
          chunk = 2;
        for (let i = 0, j = items.length; i < j; i += chunk) {
          finalArray.push(items.slice(i, i + chunk));
        }

        return finalArray;
      },
      isUnlockedItem(item) {
        return this.pathfinder.unlocked_items.includes(item.key);
      },
      itemUrl(item) {
        return this.isUnlockedItem(item) ? item.icon : lockedBoxUrl;
      },
      isSelectedItem(item) {
        return this.pathfinder.items.includes(item.key);
      },
      toggleSelect(item) {
        if (this.isUnlockedItem(item)) {
          this.toggleItem(item.key);
        }
      },
      isUnlockedElement(element) {
        return this.pathfinder.unlocked_elements.includes(element.key);
      },
      elementUrl(element) {
        return this.isUnlockedElement(element) ? element.icon : lockedBoxUrl;
      },
      isSelectedElement(element) {
        return this.pathfinder.element === element.key;
      },
      selectElement(element) {
        if (this.isUnlockedElement(element)) {
          this.toggleElement(element.key);
        }
      }
    }
  };
</script>

<style lang="scss">
  .items {
    display: flex;
    flex-direction: column;
    align-items: center;

    .notice {
      width: 75%;
      margin-bottom: 2em;
    }

    .item-level {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 2em;

      .item {
        width: 25%;
        margin-left: 1em;
        margin-right: 1em;
      }

      .item.selected {
        opacity: 0.25;
      }
    }
  }
</style>
